import {updateMask} from 'assets/js/utils/update-mask'

const live = {
	state:     {
		previousWidth: window.innerWidth,
	},
	elements:  {
		hero:   {
			$section: $('.js-live-hero'),
		},
		larger: {
			$section: $('.js-live-larger'),
			images:   {
				$left:   $('.js-live-larger-image-left'),
				$center: $('.js-live-larger-image-center'),
				$right:  $('.js-live-larger-image-right'),
			},
			$text:    $('.js-live-larger-text'),
		},
		footer: {
			$section: $('.js-live-footer'),
		},
		video:  {
			$section: $('.js-live-video'),
			$sticky:  $('.js-live-video-sticky'),
			$video:   $('.js-live-video-background'),
		},
	},
	modifiers: {
		liveLargerBackground: 'live-larger--background',
	},

	init() {
		this.initVideo()
		this.initAnimations()
	},

	setVideoSrc() {
		const videoUrl = window.innerWidth > 768 ? this.elements.video.$video.attr('data-src-desktop') : this.elements.video.$video.attr('data-src-mobile')
		this.elements.video.$video.attr('src', videoUrl)
	},
	initVideo() {
		this.setVideoSrc()

		window.addEventListener('resize', () => {
			if (this.state.previousWidth === window.innerWidth) {
				return
			}
			this.state.previousWidth = window.innerWidth

			this.setVideoSrc()
		})
	},

	initAnimations() {
		// Hero progress
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.hero.$section,
				start:               'top bottom',
				end:                 () => `+=${window.vh * 200}`,
				scrub:               true,
				invalidateOnRefresh: true,
				onUpdate:            () => {
					updateMask(this.elements.hero.$section[0], 'live-hero-mask')
				},
			},
		}).to(this.elements.hero.$section, {
			'--live-hero-progress': 1,
		})

		// Larger progress
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.larger.$section,
				start:               'top bottom',
				end:                 () => `+=${window.vh * 200}`,
				scrub:               true,
				invalidateOnRefresh: true,
				onUpdate:            () => {
					updateMask(this.elements.hero.$section[0], 'live-hero-mask')
				},
			},
		}).to(this.elements.larger.$section, {
			'--live-larger-progress': 1,
		})

		// Footer progress
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.larger.$section,
				start:               'bottom bottom',
				end:                 () => `+=${window.vh * 200}`,
				scrub:               true,
				invalidateOnRefresh: true,
				onEnter:             () => {
					this.elements.hero.$section.css('visibility', 'hidden')
					this.elements.larger.$section.removeClass(this.modifiers.liveLargerBackground)
				},
				onLeaveBack:         () => {
					this.elements.hero.$section.css('visibility', 'visible')
					this.elements.larger.$section.addClass(this.modifiers.liveLargerBackground)
				},
			},
		}).to(this.elements.footer.$section, {
			'--live-footer-progress': 1,
		})

		// Video progress
		window.gsap.timeline({
			defaults:      {
				ease: 'none',
			},
			scrollTrigger: {
				trigger:             this.elements.video.$section,
				start:               'top top',
				end:                 () => `+=${window.vh * 200}`,
				scrub:               true,
				invalidateOnRefresh: true,
				onUpdate:            () => {
					updateMask(this.elements.hero.$section[0], 'live-video-mask')
				},
			},
		}).to(this.elements.video.$section, {
			'--live-video-progress': 1,
		})
	},
}
export default live
